import { ProVesselTypes } from './pro.model';

// See Doc https://roke-bu09.atlassian.net/wiki/spaces/NO/pages/569081857/MyFleet+Vessel+and+Alert+Batch+Operations
// for rationale and test results for these values.
export const MAX_VESSEL_BATCH_SIZE = 10000;
export const MAX_ALERT_CREATION_BATCH_SIZE = 1;
export const MAX_ALERT_CONCURRENCY_SIZE = 10;
export const MAX_VESSEL_CREATION_BATCH_SIZE = 10;
export const MAX_VESSEL_CONCURRENCY_SIZE = 5;
export const MAX_VESSEL_DELETION_BATCH_SIZE = 1;
export const MAX_VESSEL_DELETION_CONCURRENCY_SIZE = 10;
export const MAX_VESSEL_EMAIL_RECIPIENTS_LIMIT = 20;
export const MAX_MANUAL_VESSEL_LIMIT = 10;

export interface MyFleetVessel {
  name?: string;
  imo: string;
  vessel_type?: ProVesselTypes;
  destination?: string;
  date_created?: string;
  cognito_id?: string;
  vessel_id?: string;
}

export type MyFleetVessels = MyFleetVessel[];

export interface VesselError {
  imo: string;
  vessel_type?: string;
  message: string;
}

export type UpdateMyFleetVesselsResponse = string | VesselError[];

export type AddMyFleetVesselsResponse = {
  status_code?: number;
  message: string;
  vessels?: { vessel_id: string; imo: string }[];
  errors?: VesselError[];
  completed?: number;
  failed?: number;
  total?: number;
};

export enum MyFleetDialogStatus {
  Idle = 'idle',
  Loading = 'loading',
  CreatingVessels = 'creatingVessels',
  CreatingAlerts = 'creatingAlerts',
  Error = 'error',
  VesselError = 'vesselError',
  AlertError = 'alertError',
  Success = 'success',
}

export enum MyFleetActionButtonGroupStatus {
  Idle = 'idle',
  Download = 'download',
  Delete = 'delete',
}

export interface MyFleetVesselDeleteRequest {
  imos: string[];
}

export type DeleteMyFleetVesselsResponse = string | VesselError[];

export interface MyFleetVesselUpdateRequest {
  vessel_id: string;
  name?: string;
  vessel_type?: ProVesselTypes;
}

export enum VesselOption {
  Edit = 'edit',
  Alert = 'alert',
  DeleteAlert = 'deleteAlert',
}

export type ActiveVesselOption = {
  type: VesselOption | null;
  imo: string | null;
};

// MyFleetCsvHeaders maps logical field names to the expected CSV column header names (in lower case),
// as they appear in the uploaded CSV file. These are used for parsing the CSV data.
export const MyFleetCsvHeaders = {
  IMO: 'imo',
  Ship: 'ship',
  VesselContactEmails: 'vessel contact emails',
  ShoreContactEmails: 'shore contact emails',
};

// MyFleetCsvHeaderDisplayNames maps the CSV header keys (from MyFleetCsvHeaders)
// to user-friendly display names (with proper case) for UI and error messages.
export const MyFleetCsvHeaderDisplayNames = {
  [MyFleetCsvHeaders.IMO]: 'IMO',
  [MyFleetCsvHeaders.VesselContactEmails]: 'Vessel Contact Emails',
  [MyFleetCsvHeaders.ShoreContactEmails]: 'Shore Contact Emails',
};
